import React from 'react';
import { useParams } from 'react-router-dom';
import '../../App.css';
import Slides from "../Slides";
import ProjectShowcase from "../projectShowcase";
import { projects } from "../../projects";
import ScrollToTop from "../ScrollToTop";  // Assuming 'projects' is an array containing all your project data

export default function Services() {
  const { projectId } = useParams();  // Get the projectId from the URL

  // Find the project by its ID
  const project = projects.find(p => p.projectId === projectId);
  if (!project) {
    return <div>Project not found.</div>;
  }

  const projectIds = projects.map(p => p.projectId);

  return (
    <>
      <section>
        <Slides images={project.images} projectId={project.projectId}/>  {/* Pass the images array to the Slides component */}
      </section>
      <section>
        <ProjectShowcase currentProject={project} projectsList={projectIds}/>  {/* Pass the project data to the ProjectShowcase component */}
      </section>
    </>
  );
}
